import I18n from 'I18n';
import { List } from 'immutable';
import { NAV_ITEMS } from 'knowledge-content-ui/constants/TemplateEditorConstants';
import * as ActionTypes from './ActionTypes';
import { templatePreviewShowLoadingOverlay } from './TemplateEditorActions';
import { getTranslatedCategoryOrganizationWithArticles } from './edit/CategoryActions';
import { selectKnowledgeBaseId } from '../knowledge-base/selectors/knowledgeBaseDetails';
const updateTemplateEditorNavigationContext = (navItemLabels, navItems, selectedNavItem, previewPage) => {
  return {
    type: ActionTypes.TEMPLATE_EDITOR_NAVIGATION_CONTEXT_CHANGE,
    payload: {
      navItemLabels,
      navItems,
      selectedNavItem,
      previewPage
    }
  };
};
export function updateSelectedPreviewPage(value) {
  return (dispatch, getState) => {
    const {
      templateEditorNavigationContext: {
        navItemLabels,
        navItems,
        selectedNavItem,
        previewPage
      }
    } = getState();
    const updatedPreviewPage = value || previewPage;
    dispatch(updateTemplateEditorNavigationContext(navItemLabels, navItems, selectedNavItem, updatedPreviewPage));
  };
}
export function updateSelectedNavItem(value, isCategoryId = false) {
  return (dispatch, getState) => {
    const {
      categoryOrganizationInfo: {
        categories
      },
      templateEditorNavigationContext: {
        navItemLabels,
        navItems,
        previewPage
      }
    } = getState();
    const selectedNavItem = isCategoryId ? {
      type: NAV_ITEMS.CATEGORY_ID,
      itemValue: value
    } : {
      type: value
    };
    const leafNavIndex = navItems.indexOf(selectedNavItem.type);
    if (leafNavIndex >= 0) {
      const navItemLabelsSliced = navItemLabels.slice(0, leafNavIndex + 1);
      const navItemsSliced = navItems.slice(0, leafNavIndex + 1);
      dispatch(updateTemplateEditorNavigationContext(navItemLabelsSliced, navItemsSliced, selectedNavItem, previewPage));
    } else {
      const label = isCategoryId ? categories.get(value).name : I18n.text(`knowledgeContentUI.templateEditor.sidebar.navItems.${value}.breadcrumbText`);
      dispatch(updateTemplateEditorNavigationContext(navItemLabels.push(label), navItems.push(selectedNavItem.type), selectedNavItem, previewPage));
    }
    const {
      templateEditorNavigationContext: {
        previewPage: nextPreviewPage
      }
    } = getState();
    if (nextPreviewPage !== previewPage) {
      dispatch(templatePreviewShowLoadingOverlay());
    }
  };
}
export function updateSelectedNavItemPath(navItemPath, categoryId, {
  queryPreviewPage
}) {
  return (dispatch, getState) => {
    const hasCategoryId = categoryId !== undefined && categoryId !== null;
    if (!navItemPath || navItemPath.length === 0 && !hasCategoryId) {
      return;
    }
    const {
      categoryOrganizationInfo: {
        categories
      },
      templateEditorNavigationContext: {
        previewPage
      }
    } = getState();
    const navItemLabels = [];
    const navItems = navItemPath.slice();
    const selectedNavItem = hasCategoryId ? {
      type: NAV_ITEMS.CATEGORY_ID,
      itemValue: categoryId
    } : {
      type: navItemPath[navItemPath.length - 1]
    };
    const updatedPreviewPage = queryPreviewPage || previewPage;
    navItems.forEach(navItem => {
      navItemLabels.push(I18n.text(`knowledgeContentUI.templateEditor.sidebar.navItems.${navItem}.breadcrumbText`));
    });
    if (hasCategoryId) {
      navItemLabels.push(categories.get(categoryId).name);
      navItems.push(NAV_ITEMS.CATEGORY_ID);
    }
    dispatch(updateTemplateEditorNavigationContext(
    // @ts-expect-error ts-migrate(7009) FIXME: 'new' expression, whose target lacks a construct s... Remove this comment to see the full error message
    new List(navItemLabels),
    // @ts-expect-error ts-migrate(7009) FIXME: 'new' expression, whose target lacks a construct s... Remove this comment to see the full error message
    new List(navItems), selectedNavItem, updatedPreviewPage));
  };
}
export function selectTemplateEditorLanguage(lang) {
  return (dispatch, getState) => {
    dispatch({
      type: ActionTypes.TEMPLATE_EDITOR_SELECT_LANGUAGE,
      payload: lang
    });
    const knowledgeBaseId = selectKnowledgeBaseId(getState());
    dispatch(getTranslatedCategoryOrganizationWithArticles(knowledgeBaseId, lang));
  };
}